import PropTypes from 'prop-types';

import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
import logoPayluddBlackAndWhite from 'url:../../../../../../../resource/images/Logo_Payludd_N&B.png';
import logoPayludd from 'url:../../../../../../../resource/images/payludd.png';
import ORIGIN_APPLICATION from '../../../enums/OriginApplication';
/**
 *
 * @param {Object} root0
 * @param {string} root0.originApplication - The origin application
 * @returns {JSX} RenderOriginApplication
 */
function RenderOriginApplication({ originApplication }) {
    const { PAYLUDD, BROADCAST } = ORIGIN_APPLICATION;
    const applications = {
        PAYLUDD: {
            logo: logoPayludd,
            title: PAYLUDD.title,
            alt: PAYLUDD.title
        },
        BROADCAST: {
            logo: logoPayluddBlackAndWhite,
            title: BROADCAST.title,
            alt: BROADCAST.title
        },
        DEFAULT: {
            logo: null,
            title: '',
            alt: ''
        }
    };
    const application = applications[originApplication] || applications.DEFAULT;
    return (
        <div className='w-8 h-'>
            {
                application.logo &&
                <TooltipHelper
                    trigger={
                        <img
                            alt={application.alt}
                            src={application.logo}
                        />
                    }
                    content={application.title}
                />
            }
        </div>
    );
}

RenderOriginApplication.propTypes = {
    originApplication: PropTypes.string
};

export default RenderOriginApplication;